<style>
.lbl-title {
  color: red;
  font-weight: bold;
  font-size: 20px;
  padding-bottom: 10px;
}
.td-col {
  font-size: 15px;
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>

<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Mis Cuentas</b-card-header>

      <b-card-body v-if="Section.SelectPsp">

    <!-- <web-view
        :source="{uri:'https://consentimiento-homo.bancoprovincia.com.ar/auth?response_type=code&code_challenge=1TBGoXSeafK6YcG-8YtQUOvXYbO4DivD_IKKzi0qv7o&code_challenge_method=S256&user_identifier=20001234561&client_id=33544&redirect_uri=https://uatapi-external.resimple.com.ar/api/Enrollment/AuthorizeCallback&scope=openid%20offline_access%20accounts.debit&state=b514cc7d-b380-45e5-afd7-95119961ebbd'}"
        :style="{marginTop: 20}"
    /> -->

    <!-- <web-view
        :source="{uri:'https://google.com'}"
        :style="{marginTop: 20}"
    /> -->


        <div class="col-md-12 text-center lbl-title">Elegí tu proveedor de cuenta</div>
        <div
          class="col-md-12 text-center"
          style="padding-bottom:30px;font-size:13px"
        >Es necesario que esté a tu nombre!</div>

        <div class="row" style="margin-top: 5px">
          <div class="col-md-12 text-center">
            <img src="/img/add_university.png" />
          </div>

          <div class="col-md-7" style="margin: auto;padding-top:20px">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Psp"
              addon-left-icon="fa fa-fw fa-search"
              @keyup="FindPspKeyUp()"
              v-model="pspName"
            ></base-input>
          </div>

          <div
            v-if="pspListLenght == 0"
            class="col-md-6 text-center"
            style="margin: auto;padding-top:40px"
          >
            <div>No se encontraron registros</div>
            <img src="/img/ic_no_resultado.png" style="width: 200px;" />
          </div>
          <div
            class="col-md-6 text-center"
            v-else
            style="overflow-y:scroll;max-height: 370px;overflow-y: auto;overflow-x:hidden;width: 60%; margin: auto;padding-top:40px"
          >
            <div
              v-for="psp in this.pspList"
              v-bind:key="psp.EntityID"
              @click="ClickPsp(psp)"
              style="border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
            >
              <div
                class="row"
                style="border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-md-3 text-center">
                  <img :src="psp.Image" class="circle-img" style="width: 40px" alt />
                </div>
                <div class="col-6 text-left td-col">{{psp.BusinessName}}</div>

                <div class="col-3 td-col">
                  <i class="fa fa-angle-right"></i>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row" style="margin-top: 30px"> -->
          <div class="col-md-12 text-center" style="padding-top:40px">
            <b-button class="btn btn-danger" @click="GoBackFromSelectPsp()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
          </div>
          <!-- </div> -->
        </div>
      </b-card-body>

      <b-card-body v-if="Section.AcceptPsp">
        <div class="col-md-12 text-center lbl-title">Asociar proveedor de cuenta</div>
        <div
          class="col-md-4 offset-4 text-center"
          style="padding-bottom:30px;font-size:13px"
        >Para asociar tus cuentas, te redireccionaremos a tu proveedor de cuenta para que inicies sesión y lo conectes con tu billetera Resimple</div>

        <div class="row" style="margin-top: 5px">
          <div class="col-md-12 text-center">
            <img src="img/enrolar.png" />
          </div>
        </div>

        <div class="row" style="margin-top: 5px">
          <div class="col-md-12 text-center" style="padding-top:50px;font-size:13px">Asociar con</div>
          <div class="col-md-12 text-center">
            <img :src="AccountPsp.Image" class="circle-img" style="width: 80px" alt />
          </div>
          <div class="col-md-12 text-center" style="font-weight:bold">{{AccountPsp.Name}}</div>
          <div class="col-md-12 text-center" style="font-size:13px">Al continuar estas aceptando los</div>
          <div class="col-md-12 text-center">
            <a
              href="https://www.resimple.com.ar/legales"
              style="font-size:13px"
            >Términos y condiciones</a>
          </div>
        </div>

        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-center">
            <b-button class="btn btn-danger" @click="GoBackFromAcceptPsp()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
            <b-button class="btn btn-success" @click="GoToWebViewPsp()">
              <i class="fa fa-check-circle fa-fw"></i>Aceptar
            </b-button>
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="Section.ExistingPsp">
        <div class="col-md-12 text-center lbl-title">Proveedor de cuenta existente!</div>
        <div
          class="col-md-4 offset-4 text-center"
          style="padding-bottom:30px;font-size:13px"
        >Ya tenés cuentas asociadas con éste proveedor</div>

        <!-- <div class="row" style="margin-top: 5px">
          <div class="col-md-12 text-center">
            <img src="img/enrolar.png" />
          </div>
        </div>-->

        <div class="row" style="margin-top: 5px">
          <div class="col-md-12 text-center">
            <img :src="AccountPsp.Image" class="circle-img" style="width: 80px" alt />
          </div>
          <div class="col-md-12 text-center" style="font-weight:bold">{{AccountPsp.Name}}</div>
          <div class="col-md-12 text-center" style="font-size:13px;padding-top:30px">
            IMPORTANTE!
            <br />Para agregar una nueva cuenta de éste proveedor, deberás
            <br />realizar la baja de todas las cuentas asociadas al mismo y
            <br />volver a completar el proceso de enrolamiento.
            <br />Luego podrás elegir qué cuentas agendar.
          </div>
        </div>

        <div class="row" style="margin-top: 30px">
          <div class="col-md-12 text-center">
            <b-button class="btn btn-danger" @click="GoBackFromExistingPsp()">
              <i class="fa fa-arrow-circle-left fa-fw"></i>Volver
            </b-button>
            <b-button class="btn btn-success" @click="GoToDeletePSP()">
              <i class="fa fa-check-circle fa-fw"></i>Aceptar
            </b-button>
          </div>
        </div>
      </b-card-body>

      <b-card-body v-if="Section.WebViewPsp">
        <template>
          <div class="container">
            <iframe
              :src="AccountPsp.UrlRecruitment"
              width="100%"
              height="550px"
              frameborder="0"
              name="my-frame"
            ></iframe>
          </div>
          <!-- <div style="text-align:center;">
            <iframe
              height="500"
              width="1000"
              src="https://consentimiento-homo.bancoprovincia.com.ar/authorize?response_type=code&code_challenge=1TBGoXSeafK6YcG-8YtQUOvXYbO4DivD_IKKzi0qv7o&code_challenge_method=S256&user_identifier=20001234561&client_id=33544&redirect_uri=https://uatapi-external.resimple.com.ar/api/Enrollment/AuthorizeCallback&scope=openid%20offline_access%20accounts.debit&state=b514cc7d-b380-45e5-afd7-95119961ebbd"
            ></iframe>
          </div> -->
        </template>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
// import { hubConnection } from "signalr-no-jquery";
//import { WebView } from "react-native-webview";

export default {
  // components: { "web-view": WebView},
  data() {
    return {
      pspList: [],
      pspListLenght: 0,
      pspID: 0,
      pspName: "",
      Section: {
        SelectPsp: false,
        AcceptPsp: false,
        ExistingPsp: false,
        WebViewPsp: false
      },
      AccountPsp: {
        Name: "",
        Image: "",
        UrlRecruitment: ""
      }
    };
  },
  methods: {
    GetAllPsp() {
      let context = this;

      context.pspList = [];

      axiosHelpers.axiosGet(
        "RecruitmentAccountsPsp/GetAllPsp",
        { Name: context.pspName },
        context,
        function(data) {
          context.pspList = data.ResponseVM.Items;
          context.pspListLenght = data.ResponseVM.Items.lenght;
        }
      );
    },
    FindPspKeyUp() {
      if (this.pspName.length >= 3 || this.pspName.length == 0) {
        this.GetAllPsp();
      }
    },
    ClickPsp(psp) {
      let context = this;

      context.pspID = psp.EntityID;
      context.AccountPsp.Name = psp.BusinessName;
      context.AccountPsp.Image = psp.Image;

      axiosHelpers.axiosGet(
        "RecruitmentAccountsPsp/GetExistingPSPAccount",
        { PspID: psp.EntityID },
        context,
        function(data) {
          if (data.ResponseVM.HasAccount) {
            context.GoToExistingPsp();
          } else {
            context.GoToAcceptPspWindow();
          }
        }
      );
    },
    GetRecruitmentUri() {
      let context = this;

      axiosHelpers.axiosGet(
        "COELSA/EnrollAccount",
        { PSPID: context.pspID },
        context,
        function(data) {
          if (data.ResponseVM.Success) {
            context.AccountPsp.UrlRecruitment = data.ResponseVM.Uri;
            //let location= data.ResponseVM.HttpResponseMessage.Headers.find(obj => obj.Key === 'Location');
            //context.AccountPsp.UrlRecruitment= location.Value;
            context.StartConecction();
          } else {
          }
        }
      );
    },
    GoToSelectPsp() {
      this.GetAllPsp();
      this.ShowSection(true, false, false, false);
    },
    GoToAcceptPspWindow() {
      this.ShowSection(false, true, false, false);
    },
    GoToExistingPsp() {
      this.ShowSection(false, false, true, false);
    },
    GoToDeletePSP() {
      let context = this;

      context.$router.push({
        name: "EliminarPSP",
        params: { PspIDProp: context.pspID }
      });
    },
    GoToWebViewPsp() {
      this.GetRecruitmentUri();
      this.ShowSection(false, false, false, true);
    },

    ShowSection(SelectPsp, AcceptPsp, ExistingPsp, WebViewPsp) {
      this.Section.SelectPsp = SelectPsp;
      this.Section.AcceptPsp = AcceptPsp;
      this.Section.ExistingPsp = ExistingPsp;
      this.Section.WebViewPsp = WebViewPsp;
    },
    GoBackFromSelectPsp() {
      this.$router.push("miscuentas");
    },
    GoBackFromAcceptPsp() {
      this.GoToSelectPsp();
    },
    GoBackFromExistingPsp() {
      this.GoToSelectPsp();
    },
    GoBackFromWebViewPsp() {},
    StartConecction() {
      let context = this;

      const connection = hubConnection("https://test-signalr.resimple.com.ar");
      const hubProxy = connection.createHubProxy("CashHub");

      hubProxy.on("Notify", function(message) {
        console.log(message);
        //NotifyDTO   Operation AccountID
      });

      connection
        .start({ jsonp: false })
        .done(function() {
          console.log("Now connected, connection ID=" + connection.id);
          hubProxy.invoke("Registrarse", {
            AccountID: context.$store.getters.accountID
          });
        })
        .fail(function() {
          console.log("Could not connect");
        });

      return {};
    }
  },
  beforeMount: function() {
    this.Section.SelectPsp = true;
    this.GetAllPsp();
  }
};
</script>